import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HomeGuard  {
    private router = inject(Router);


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // if (!this.loginService.isLoggednIn()) {
            return true;
        // } else {
        //     this.router.navigate(['/mwsp/home']);
        //     return false;
        // }
    }
}
